import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  autocomplete: "off",
  class: "flex flex-col gap-3"
}
const _hoisted_2 = { class: "grid grid-cols-1 gap-x-4 gap-y-6 sm:grid-cols-6" }
const _hoisted_3 = { class: "sm:col-span-5" }
const _hoisted_4 = { class: "block text-sm font-medium text-gray-800" }
const _hoisted_5 = { class: "grid grid-cols-1 gap-x-4 gap-y-6 sm:grid-cols-6" }
const _hoisted_6 = { class: "sm:col-span-5" }
const _hoisted_7 = { class: "block text-sm font-medium text-gray-800" }
const _hoisted_8 = { class: "grid grid-cols-1 gap-x-4 gap-y-6 sm:grid-cols-6" }
const _hoisted_9 = { class: "sm:col-span-5" }
const _hoisted_10 = { class: "block text-sm font-medium text-gray-800" }
const _hoisted_11 = { class: "grid grid-cols-1 gap-x-4 gap-y-6 sm:grid-cols-6" }
const _hoisted_12 = { class: "sm:col-span-5" }
const _hoisted_13 = { class: "block text-sm font-medium text-gray-800" }
const _hoisted_14 = { class: "mt-4 grid grid-cols-2 place-content-around gap-4" }

import { RealtimeReportService, SelectOptionsService, toastServiceError } from '@/services';
import store from '@/store';
import {
    AgentExtensionReportActions,
    AgentExtensionReportFilter,
    AgentExtensionReportGetters,
    MultiSelectOption,
    SelectOptionsServiceGetQueuesResult,
    SelectOptionsServiceGetUserLabelsResult,
    SelectOptionsServiceGetUsersResult,
    UserDeviceStatus,
} from '@/types';
import { FilterIcon } from '@heroicons/vue/solid';
import { computed, onMounted, Ref, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'AgentExtensionReportFilters',
  setup(__props) {

const { t } = useI18n();

const defaultFilter = computed(() => store.getters[AgentExtensionReportGetters.DEFAULT_FILTER]);
const storeFilter = computed(() => store.getters[AgentExtensionReportGetters.FILTER]);

const filterOpened = ref(false);

const filter: Ref<AgentExtensionReportFilter> = ref({
    status: defaultFilter.value.status,
    user: defaultFilter.value.user,
    userLabel: defaultFilter.value.userLabel,
    queue: defaultFilter.value.queue,
});

// Options
const userOptions: Ref<SelectOptionsServiceGetUsersResult[]> = ref([]);
const userLabelOptions: Ref<SelectOptionsServiceGetUserLabelsResult[]> = ref([]);
const queueOptions: Ref<SelectOptionsServiceGetQueuesResult[]> = ref([]);
const statusOptions: Ref<MultiSelectOption[]> = ref([
    {
        value: UserDeviceStatus.CONNECTED,
        label: t('report.realtimeAgentExtension.device.status.CONNECTED'),
    },
    {
        value: UserDeviceStatus.OFFLINE,
        label: t('report.realtimeAgentExtension.device.status.OFFLINE'),
    },
    {
        value: UserDeviceStatus.IN_PAUSE,
        label: t('report.realtimeAgentExtension.device.status.IN_PAUSE'),
    },
]);

watch(filterOpened, () => {
    refreshLocalFilter();
});

const fetchUsers = async () => {
    try {
        const response = await RealtimeReportService.getUserDevices();
        const users = new Map<number, SelectOptionsServiceGetUsersResult>();
        for (const userDevice of response.data) {
            const user = userDevice.user;
            const extensionNumber = user.extension?.number;

            if (extensionNumber === undefined) continue;

            if (!users.has(extensionNumber)) {
                users.set(extensionNumber, {
                    id: extensionNumber,
                    name: user.name,
                    labels: [],
                });
            }
        }
        userOptions.value = Array.from(users.values());
    } catch (error) {
        toastServiceError(error);
    }
};

const fetchUserLabels = async () => {
    try {
        const response = await SelectOptionsService.getUserLabels();
        userLabelOptions.value = response.data;
    } catch (error) {
        toastServiceError(error);
    }
};

const fetchQueues = async () => {
    try {
        const response = await SelectOptionsService.getQueues();
        queueOptions.value = response.data;
    } catch (error) {
        toastServiceError(error);
    }
};

const applyFilters = () => {
    store.dispatch(AgentExtensionReportActions.SET_FILTER, filter.value);
};

const clearFilters = () => {
    store.dispatch(AgentExtensionReportActions.CLEAR_FILTER);
    refreshLocalFilter();
};

const refreshLocalFilter = () => {
    filter.value.status = storeFilter.value.status;
    filter.value.user = storeFilter.value.user;
    filter.value.userLabel = storeFilter.value.userLabel;
    filter.value.queue = storeFilter.value.queue;
};

onMounted(() => {
    fetchUsers();
    fetchUserLabels();
    fetchQueues();
});

return (_ctx: any,_cache: any) => {
  const _component_UiButton = _resolveComponent("UiButton")!
  const _component_UiMultiselect = _resolveComponent("UiMultiselect")!
  const _component_UiRightPanel = _resolveComponent("UiRightPanel")!

  return (_openBlock(), _createBlock(_component_UiRightPanel, {
    modelValue: filterOpened.value,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((filterOpened).value = $event)),
    title: _ctx.$t('filter.sidebar.title')
  }, {
    button: _withCtx(() => [
      _createVNode(_component_UiButton, {
        size: "md",
        variant: "white",
        "text-variant": "gray-700",
        class: "focus:ring-primary border border-gray-300 shadow-none hover:bg-gray-50",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (filterOpened.value = true))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(FilterIcon), {
            class: "mr-3 h-5 w-5 text-gray-400",
            "aria-hidden": "true"
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('core.actions.Filter')), 1)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("form", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('report.realtimeAgentExtension.filters.status')), 1),
            _createVNode(_component_UiMultiselect, {
              name: "filter_type",
              modelValue: filter.value.status,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filter.value.status) = $event)),
              options: statusOptions.value,
              "can-clear": "",
              placeholder: _unref(t)('core.options.All')
            }, null, 8, ["modelValue", "options", "placeholder"])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('report.realtimeAgentExtension.filters.user')), 1),
            _createVNode(_component_UiMultiselect, {
              name: "filter_user",
              modelValue: filter.value.user,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filter.value.user) = $event)),
              options: userOptions.value,
              label: "name",
              "value-prop": "id",
              "can-clear": "",
              placeholder: _unref(t)('core.options.All')
            }, null, 8, ["modelValue", "options", "placeholder"])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('report.realtimeAgentExtension.filters.userLabel')), 1),
            _createVNode(_component_UiMultiselect, {
              name: "filter_userLabel",
              modelValue: filter.value.userLabel,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filter.value.userLabel) = $event)),
              label: "label",
              "value-prop": "id",
              options: userLabelOptions.value,
              placeholder: _unref(t)('core.options.All'),
              "can-clear": ""
            }, null, 8, ["modelValue", "options", "placeholder"])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('report.realtimeAgentExtension.filters.queue')), 1),
            _createVNode(_component_UiMultiselect, {
              name: "filter_queue",
              modelValue: filter.value.queue,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filter.value.queue) = $event)),
              options: queueOptions.value,
              label: "name",
              "value-prop": "id",
              "can-clear": "",
              placeholder: _unref(t)('core.options.All')
            }, null, 8, ["modelValue", "options", "placeholder"])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_UiButton, {
            variant: "white",
            "text-variant": "gray-700",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (clearFilters()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('core.actions.Clear')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_UiButton, {
            variant: "primary",
            "text-variant": "white",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (applyFilters()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('core.actions.Apply')), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})